import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { API_HOST } from "../../constants";
import SearchList from "./SearchList";
import Pagination from "../ui/Pagination";
import LoadingAnime from "../Common/LoadingAnime";
import EmptyState from "../ui/EmptyState";

function SearchResults() {
  const [searchParams, setSearchParams] = useSearchParams();
  const query = searchParams.get("q") || "";
  const [results, setResults] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(() => parseInt(searchParams.get("page"), 10) || 1);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setCurrentPage(parseInt(searchParams.get("page"), 10) || 1);
  }, [searchParams]);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${API_HOST}/api/search/bbs/`, { params: { q: query, page: currentPage } })
      .then((response) => {
        setResults(response.data.results || []);
        setTotalPages(response.data.total_pages || 1);
      })
      .catch(() => {
        setResults([]);
        setTotalPages(1);
      })
      .finally(() => setLoading(false));
  }, [query, currentPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    const params = new URLSearchParams(searchParams);
    params.set("page", page);
    setSearchParams(params);
  };

  if (loading) return <LoadingAnime label="검색 결과 로딩 중..." />;

  return (
    <div className="space-y-6">
      <section className="glass-card p-6">
        <h1 className="font-display text-3xl text-white">검색 결과</h1>
        <p className="mt-2 text-sm text-ink-200">"{query}"에 대한 최신 게시글을 확인하세요.</p>
      </section>
      <section className="glass-card p-6">
        {results.length ? (
          <SearchList posts={results} />
        ) : (
          <EmptyState title="검색 결과가 없습니다" description="다른 키워드로 다시 검색해보세요." />
        )}
      </section>
      <section className="glass-card p-6">
        <Pagination totalPages={totalPages} currentPage={currentPage} onPageChange={handlePageChange} />
      </section>
    </div>
  );
}

export default SearchResults;
